import type { ImgHTMLAttributes } from "react";

type OptimizedImageProps = ImgHTMLAttributes<HTMLImageElement> & {
  eager?: boolean;
};

export default function OptimizedImage({
  eager = false,
  loading,
  decoding,
  fetchPriority,
  ...props
}: OptimizedImageProps) {
  return (
    <img
      {...props}
      loading={loading ?? (eager ? "eager" : "lazy")}
      decoding={decoding ?? "async"}
      fetchPriority={fetchPriority ?? (eager ? "high" : "auto")}
    />
  );
}

export { OptimizedImage };
